import MiniBanner from './components/MiniBanner.vue';

new Vue({
	el: '#MiniBanner',
	components: { MiniBanner },
});
